import { Pane, Heading, Paragraph, UnorderedList, ListItem, Text, Table, Link } from 'evergreen-ui';

const PrivacyPage = () => {
  return (
    <Pane maxWidth={900} marginX="auto" padding={32}>

      <Heading size={900} marginBottom={8}>Informativa sul trattamento dei dati personali</Heading>
      <Paragraph size={300} color="muted" marginBottom={32}>
        Ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) — Versione 3.1 del 01/06/2026
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 1. TITOLARE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>1. Titolare del trattamento</Heading>
      <Paragraph size={400} marginBottom={4}>
        <strong>Casa Letizia GAAG</strong> (Gruppo Appartamento Adolescenti e Giovani)
      </Paragraph>
      <Paragraph size={400} marginBottom={4}>Via Vandalino 25, 10093 Collegno (TO) — Italia</Paragraph>
      <Paragraph size={400} marginBottom={4}>Codice Fiscale / P.IVA: 13037730010</Paragraph>
      <Paragraph size={400} marginBottom={24}>
        E-mail: <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link>
      </Paragraph>
      <Paragraph size={300} color="muted" marginBottom={32}>
        Per qualsiasi questione relativa al trattamento dei tuoi dati personali puoi contattare il Titolare ai recapiti indicati sopra.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 2. AMBITO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>2. Ambito della presente informativa</Heading>
      <Paragraph size={400} marginBottom={12}>
        La presente informativa riguarda esclusivamente il trattamento dei dati personali dei <strong>visitatori del sito web pubblico</strong> di Casa Letizia (pagine accessibili senza autenticazione: Home, Chi Siamo, Cosa Facciamo, La Casa, Il Metodo, Contatti, Privacy, Cookie Policy, Termini e Condizioni).
      </Paragraph>
      <Paragraph size={400} marginBottom={32}>
        Per i trattamenti effettuati all'interno dell'area riservata sono disponibili informative dedicate:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          <Link href="/informativa-ospiti">Informativa per gli Ospiti (Minori) accolti nella struttura</Link> — trattamento di dati anagrafici, sanitari, educativi e giudiziari degli ospiti minori.
        </ListItem>
        <ListItem>
          <Link href="/informativa-collaboratori">Informativa per i Collaboratori e il Personale</Link> — trattamento di dati contrattuali, retributivi e di presenza dei collaboratori e operatori.
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 3. DATI RACCOLTI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>3. Dati raccolti tramite il sito</Heading>

      <Heading size={500} marginBottom={8}>3.1 Dati di navigazione</Heading>
      <Paragraph size={400} marginBottom={12}>
        I sistemi informatici e le procedure software preposte al funzionamento del sito acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet. Si tratta di informazioni non raccolte per essere associate a persone identificate, ma che per loro stessa natura potrebbero permettere di identificare gli utenti.
      </Paragraph>
      <Paragraph size={400} marginBottom={8}>In questa categoria rientrano:</Paragraph>
      <UnorderedList marginBottom={24}>
        <ListItem>indirizzi IP o nomi a dominio dei computer utilizzati dagli utenti che si connettono al sito;</ListItem>
        <ListItem>indirizzi URI (Uniform Resource Identifier) delle risorse richieste;</ListItem>
        <ListItem>orario della richiesta;</ListItem>
        <ListItem>metodo utilizzato nel sottoporre la richiesta al server;</ListItem>
        <ListItem>dimensione del file ottenuto in risposta;</ListItem>
        <ListItem>codice numerico indicante lo stato della risposta (es. 200 OK, 404 Not Found);</ListItem>
        <ListItem>altri parametri relativi al sistema operativo e all'ambiente informatico dell'utente (browser, lingua, risoluzione).</ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={24}>
        Questi dati vengono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del sito e per controllarne il corretto funzionamento. Potrebbero essere utilizzati per l'accertamento di responsabilità in caso di ipotetici reati informatici ai danni del sito.
      </Paragraph>

      <Heading size={500} marginBottom={8}>3.2 Cookie</Heading>
      <Paragraph size={400} marginBottom={24}>
        Il sito utilizza cookie tecnici necessari al suo funzionamento e, previo consenso dell'utente, cookie di altre categorie. Per l'elenco completo e dettagliato dei cookie utilizzati, le loro finalità, durate e istruzioni per la gestione si rimanda alla <Link href="/cookie-policy">Cookie Policy</Link>.
      </Paragraph>

      <Heading size={500} marginBottom={8}>3.3 Dati forniti volontariamente dall'utente</Heading>
      <Paragraph size={400} marginBottom={32}>
        Il sito pubblico non prevede form di contatto né raccolta di dati personali tramite moduli. L'area riservata, accessibile solo da personale autorizzato tramite credenziali fornite dalla struttura, è disciplinata da informative separate (vedi sezione 2).
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 4. FINALITÀ E BASI GIURIDICHE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>4. Finalità del trattamento e basi giuridiche</Heading>
      <Paragraph size={400} marginBottom={16}>
        Il Titolare tratta i dati di navigazione per le seguenti finalità, ciascuna con la propria base giuridica ai sensi dell'art. 6 del GDPR:
      </Paragraph>

      <Pane border="default" borderRadius={4} marginBottom={24} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Finalità</Table.TextHeaderCell>
            <Table.TextHeaderCell>Base giuridica</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Erogazione del servizio web (caricamento pagine, navigazione)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Legittimo interesse del Titolare (art. 6.1.f GDPR) — necessario per il funzionamento tecnico del sito</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Sicurezza informatica e prevenzione di accessi non autorizzati o attacchi</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Legittimo interesse del Titolare (art. 6.1.f GDPR)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Memorizzazione delle preferenze sui cookie (consenso/rifiuto)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Necessario per dare esecuzione alla scelta dell'utente (art. 6.1.b GDPR)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Elaborazione di statistiche anonime sull'uso del sito</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Legittimo interesse (art. 6.1.f GDPR) — i dati vengono aggregati e anonimizzati</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>
      <Paragraph size={400} marginBottom={32}>
        Il sito non effettua attività di profilazione degli utenti, non utilizza cookie di profilazione/marketing e non raccoglie dati a fini pubblicitari.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 5. DESTINATARI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>5. Destinatari dei dati</Heading>
      <Paragraph size={400} marginBottom={12}>
        I dati di navigazione possono essere comunicati o resi accessibili ai seguenti soggetti, nominati responsabili del trattamento ex art. 28 GDPR ove previsto:
      </Paragraph>
      <UnorderedList marginBottom={12}>
        <ListItem><strong>Provider di hosting e infrastruttura web</strong> — il server su cui è ospitato il sito e le relative infrastrutture tecniche; il trattamento avviene nell'Unione Europea.</ListItem>
        <ListItem><strong>Fornitori di servizi tecnici e di manutenzione</strong> — soggetti che intervengono per la manutenzione del sito, limitatamente ai dati necessari alle operazioni di assistenza.</ListItem>
        <ListItem><strong>Google LLC</strong> — per il servizio Google Maps incorporato nel footer del sito (visualizzazione mappa della sede). Trattamento di dati descritto nella <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy di Google</Link>.</ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        I dati non vengono venduti, ceduti o comunicati a terzi per finalità commerciali o di marketing.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 6. TRASFERIMENTI EXTRA-UE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>6. Trasferimento di dati verso paesi terzi</Heading>
      <Paragraph size={400} marginBottom={32}>
        I dati di navigazione del sito sono conservati su server situati nell'Unione Europea. Non sono previsti trasferimenti sistematici di dati personali verso paesi terzi al di fuori dell'UE/SEE, ad eccezione di quanto tecnicamente necessario per l'erogazione di servizi di terze parti (es. Google Maps, il cui provider Google LLC ha sede negli USA e aderisce alle clausole contrattuali standard approvate dalla Commissione Europea ai sensi dell'art. 46 GDPR).
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 7. CONSERVAZIONE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>7. Periodo di conservazione</Heading>
      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Categoria di dato</Table.TextHeaderCell>
            <Table.TextHeaderCell>Periodo di conservazione</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Log di accesso al server (IP, timestamp, URL)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Massimo 30 giorni, salvo necessità di accertamento di reati informatici</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Cookie tecnici di sessione (PHPSESSID)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Durata della sessione di navigazione (cancellati alla chiusura del browser)</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Cookie di preferenza consenso (cookie_consent)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>365 giorni dalla data della scelta; trascorso tale periodo il banner verrà nuovamente mostrato</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>

      {/* ------------------------------------------------------------------ */}
      {/* 8. DIRITTI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>8. Diritti degli interessati</Heading>
      <Paragraph size={400} marginBottom={12}>
        In qualità di interessato, hai il diritto di esercitare in qualsiasi momento i seguenti diritti nei confronti del Titolare del trattamento, ai sensi degli artt. 15-22 del GDPR:
      </Paragraph>
      <UnorderedList marginBottom={24}>
        <ListItem>
          <strong>Diritto di accesso (art. 15)</strong> — ottenere conferma che sia in corso un trattamento di dati che ti riguardano e, in tal caso, ottenerne copia.
        </ListItem>
        <ListItem>
          <strong>Diritto di rettifica (art. 16)</strong> — ottenere la rettifica dei dati personali inesatti che ti riguardano e l'integrazione di dati incompleti.
        </ListItem>
        <ListItem>
          <strong>Diritto alla cancellazione / "diritto all'oblio" (art. 17)</strong> — ottenere la cancellazione dei dati personali che ti riguardano, nei casi previsti dalla norma.
        </ListItem>
        <ListItem>
          <strong>Diritto di limitazione del trattamento (art. 18)</strong> — ottenere la limitazione del trattamento nei casi previsti dalla norma (es. mentre si contesta l'esattezza dei dati).
        </ListItem>
        <ListItem>
          <strong>Diritto alla portabilità (art. 20)</strong> — ricevere i dati personali che ti riguardano in un formato strutturato, di uso comune e leggibile da dispositivo automatico (si applica ai trattamenti basati su consenso o contratto, effettuati con mezzi automatizzati).
        </ListItem>
        <ListItem>
          <strong>Diritto di opposizione (art. 21)</strong> — opporti in qualsiasi momento al trattamento dei tuoi dati personali per motivi connessi alla tua situazione particolare, quando il trattamento è basato su legittimo interesse.
        </ListItem>
        <ListItem>
          <strong>Diritto di non essere sottoposto a decisioni automatizzate (art. 22)</strong> — non essere sottoposto a una decisione basata unicamente sul trattamento automatizzato. Il sito non effettua processi decisionali automatizzati.
        </ListItem>
        <ListItem>
          <strong>Diritto di revoca del consenso (art. 7.3)</strong> — revocare in qualsiasi momento il consenso prestato, senza che ciò pregiudichi la liceità del trattamento effettuato prima della revoca. Per i cookie puoi revocare il consenso in qualsiasi momento tramite il banner nel footer del sito.
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        Per esercitare i tuoi diritti puoi contattare il Titolare all'indirizzo e-mail <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link> oppure per iscritto all'indirizzo della sede legale. Il Titolare risponderà alla tua richiesta entro 30 giorni dalla ricezione (prorogabili di ulteriori 60 giorni in caso di particolare complessità, con comunicazione dei motivi).
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 9. RECLAMO AL GARANTE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>9. Diritto di reclamo al Garante</Heading>
      <Paragraph size={400} marginBottom={12}>
        Hai il diritto di proporre reclamo all'Autorità di controllo competente. In Italia l'Autorità di controllo è il <strong>Garante per la protezione dei dati personali</strong>:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>Piazza Venezia, 11 — 00187 Roma (RM)</ListItem>
        <ListItem>Centralino: +39 06 696771</ListItem>
        <ListItem>E-mail: <Link href="mailto:garante@gpdp.it">garante@gpdp.it</Link></ListItem>
        <ListItem>PEC: <Link href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</Link></ListItem>
        <ListItem>Sito web: <Link href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</Link></ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 10. SICUREZZA */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>10. Misure di sicurezza</Heading>
      <Paragraph size={400} marginBottom={32}>
        Il Titolare adotta misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita, distruzione o diffusione illecita, in conformità all'art. 32 del GDPR. In particolare: il sito utilizza il protocollo HTTPS per cifrare le comunicazioni; le password degli utenti dell'area riservata sono conservate in forma di hash crittografico e mai in chiaro; gli accessi all'area riservata sono limitati al personale autorizzato tramite sistema di autenticazione con ruoli differenziati.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 11. MODIFICHE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>11. Modifiche alla presente informativa</Heading>
      <Paragraph size={400} marginBottom={32}>
        Il Titolare si riserva il diritto di modificare o aggiornare la presente informativa in qualsiasi momento, in particolare in seguito a variazioni normative. Le modifiche saranno pubblicate su questa pagina con aggiornamento della data in calce. Si invita a consultare periodicamente questa pagina.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* FOOTER */}
      {/* ------------------------------------------------------------------ */}
      <Pane borderTop="muted" paddingTop={16}>
        <Text size={300} color="muted">
          Versione 3.1 — Ultimo aggiornamento: 1 giugno 2026 | Base normativa: Reg. (UE) 2016/679 (GDPR) — D.Lgs. 196/2003 come modificato da D.Lgs. 101/2018
        </Text>
      </Pane>
      <Pane marginTop={12}>
        <Text size={300} color="muted">
          Il fornitore del sito web non è responsabile della conformità legale dei contenuti di questa pagina, che è redatta e aggiornata a cura del Titolare del trattamento.
        </Text>
      </Pane>

    </Pane>
  );
};

export default PrivacyPage;
